angular.module('lsnBase.models', []);